(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.menu-drawer__toggle-btn');
      if (!btn) return; // clicked something else, ignore

      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();

      const group = btn.closest('.menu-drawer__dropdown-group');
      if (!group) return;

      const isOpen = group.dataset.open === 'true';
      group.dataset.open = isOpen ? 'false' : 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));

      // Keep focus inside drawer
      const drawer = document.getElementById('menu-drawer');
      if (drawer) drawer.focus();
    },
    true
  ); // capture phase — fires before Dawn's listener
  } catch(e) { console.error(e); }
})();

})();
